import React, { PropsWithChildren, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DonateLogo from "../images/website_logo.png";
import "./dashboard.css";

const navItems = [
  { label: "Members", icon: "fa-solid fa-users", path: "/dashboard/members" },
  { label: "Donations", icon: "fa-regular fa-heart", path: "/dashboard/donations" },
  { label: "Volunteers", icon: "fa-solid fa-hand-holding-heart", path: "/dashboard/volunteers" },
  // { label: "Add Blog", icon: "fa-regular fa-pen-to-square", path: "/dashboard/blogs" },
  { label: "Password", icon: "fa-solid fa-lock", path: "/dashboard/change-password" },
];

const DashboardLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/admin");
    }
  }, [navigate]);

  const isActive = (path: string) => {
    if (path === "/dashboard") {
      return location.pathname === "/dashboard";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="dashboard-shell">
      <header className="dashboard-topbar">
        <div className="dashboard-topbar-inner">
          <Link to="/dashboard" className="dashboard-brand">
            <img src={DonateLogo} alt="NGO Logo" className="dashboard-brand-logo" />
          </Link>
          <nav className="dashboard-nav">
            <Link to="/dashboard" className={`dashboard-link ${isActive("/dashboard") && location.pathname === "/dashboard" ? "active" : ""}`}>
              <i className="fa-solid fa-chart-line" />
              Overview
            </Link>
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`dashboard-link ${isActive(item.path) ? "active" : ""}`}
              >
                <i className={item.icon} />
                {item.label}
              </Link>
            ))}
            <button
              type="button"
              className="dashboard-link logout"
              onClick={() => {
                localStorage.removeItem("token");
                navigate("/admin");
              }}
            >
              <i className="fa-solid fa-arrow-right-from-bracket" />
              Logout
            </button>
          </nav>
        </div>
      </header>
      <main className="dashboard-main">{children}</main>
    </div>
  );
};

export default DashboardLayout;
